import React, { useEffect, useState } from 'react';
import {
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Menu,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  Button,
} from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import filter from 'assets/images/filter.svg';
import activeFilter from 'assets/images/whiteFilter.svg';
import star from 'assets/images/smStar.svg';

function CommonFilter(props) {
  const { filterdata } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValues, setSelectedValues] = useState(props?.defaultStatus || []);
  const [dropdownOpen, setDropdownOpen] = useState(filterdata?.map(() => true));

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    setSelectedValues(props?.defaultStatus || []);
  }, [props.defaultStatus]);

  const handleCheckboxChange = (event, type) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedValues((prevValues) => [...prevValues, value]);
    } else {
      setSelectedValues((prevValues) =>
        prevValues.filter((v) => v !== value)
      );
    }
  };

  const handleApply = () => {
    props?.onFilterChange(selectedValues);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickDropdown = (itemId) => {
    const updatedOpenState = dropdownOpen.map((isOpen, index) =>
      itemId === filterdata[index].id ? !isOpen : isOpen
    );
    setDropdownOpen(updatedOpenState);
  };

  const onResetFilter = () => {
    props?.onRestFilter();
    handleClose();
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        className={props?.defaultStatus?.length > 0 ? 'activeFilterIcon' : "vendorFilterIcon"}
        onClick={handleClick}
      >
        <img
          src={props?.defaultStatus?.length > 0 ? activeFilter : filter}
          alt="filtericon"
          className="filterIcon"
        />
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
      >
        <FormGroup className="filterCheckbox">
          {filterdata?.map((item, index) => (
            <div key={item.id}>
              <ListItemButton onClick={() => handleClickDropdown(item.id)} className="padding0">
                <ListItemText primary={item.primaryText} className="filterDropdown" />
                <ListItemIcon className="filterDropdownIcon">
                  {dropdownOpen[index] ? (
                    <ExpandLess className="fontMedium colorBlue" />
                  ) : (
                    <ExpandMore className="fontMedium colorBlue" />
                  )}
                </ListItemIcon>
              </ListItemButton>

              <Collapse in={dropdownOpen[index]} timeout="auto" unmountOnExit>
                <FormGroup className="filterBox">
                  {item.subItems.map((subItem) => (
                    <FormControlLabel
                      key={subItem.value}
                      control={
                        <Checkbox
                          checked={selectedValues.includes(subItem.value)}
                          onChange={(e) => handleCheckboxChange(e, item.primaryText)}
                          value={subItem.value}
                          color="primary"
                        />
                      }
                      label={
                        <div>
                          {item?.star && (
                            <img src={star} className="feedbackStar marginRight6" alt="star" />
                          )}
                          {subItem?.list || subItem?.value}
                        </div>
                      }
                    />
                  ))}
                </FormGroup>
              </Collapse>

              {index !== filterdata.length - 1 && <Divider />}
            </div>
          ))}

          <Grid container direction="row" justifyContent="space-around" spacing={2} className="marginTop">
            <Button className="filterbtnReset" onClick={onResetFilter}>Reset</Button>
            <Button className="fliterbtnDashboard" onClick={handleApply}>Apply</Button>
          </Grid>
        </FormGroup>
      </Menu>
    </>
  );
}

export default CommonFilter;
